import { AutoAwesome } from '@mui/icons-material';
import StatePanel from './StatePanel';

/**
Empty-state panel with an icon, title and description.
Uses StatusPanel for a consistent layout with error states.
*/
const InsightsEmptyState: React.FC<{ title: string; description: React.ReactNode }> = ({ title, description }) => (
    <StatePanel tone="primary" icon={<AutoAwesome color="primary" />} title={title} description={description} />
);

export default InsightsEmptyState;
